import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useCommunicationChatEventsApi } from '@/features/api/hooks/communication-chat-events/useCommunicationChatEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useUnarchiveChat = () => {
  const queryClient = useQueryClient();
  const api = useCommunicationChatEventsApi();

  return useApiMutation({
    mutationFn: (chatId: string) =>
      api.onChatUnarchiveRequest({ clientChatUnarchiveRequest: { chatId } }),
    errorMessageKey: 'unarchiveChat.failed',
    onSuccess: (_, chatId) => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.CHAT, chatId]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.OWN_CHATS]
      });
    }
  });
};
